export default {
  zh: {
    creatingOrder: '正在创建订单，请稍后',
    createOrderError: '处理订单失败'
  },
  en: {
    creatingOrder: 'Creating order now, please wait',
    createOrderError: 'Failed to process order'
  }
}



// WEBPACK FOOTER //
// ./src/components/creatingOrder/lang.js